import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

import {
  certificationPaths,
  PATH_DECISION_ANCHOR_ID,
  certificationRouteKey,
} from "@/domains/certifications/routes";
import { HeroProps } from "@/features/certifications/details/components/types";
import { ENROLLMENT_STATES } from "@/domains/certifications/constants";

import "./styles.css";

const Hero = ({ certification, contentKey }: HeroProps) => {
  const { t } = useTranslation();
  const isEnrolled =
    certification.enrollment?.state === ENROLLMENT_STATES.ACTIVE;

  const metadata = [
    t("certification.details.sessionCount", {
      count: certification.modules.length,
    }),
    t("certification.details.credentialCount", {
      count: certification.tracks.length,
    }),
    t(`${contentKey}.free`),
  ];

  return (
    <section className="certification-hero flex">
      <div className="certification-hero-body flex-1 flex flex-col gap-500">
        <div className="certification-hero-partners flex flex-wrap items-center gap-300">
          <span className="certification-hero-partnership body-s-regular">
            {t(`${contentKey}.partnership`)}
          </span>
        </div>

        <div className="flex flex-col gap-300">
          <span className="certification-eyebrow">
            {t("certification.details.eyebrow")}
          </span>

          <h1 className="certification-hero-title header-xxl-medium">
            {certification.title}
          </h1>

          {certification.subtitle && (
            <p className="certification-hero-standfirst body-m-regular">
              {certification.subtitle}
            </p>
          )}

          <ul className="certification-hero-meta flex flex-wrap gap-y-200 gap-x-400 body-xs-regular">
            {metadata.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
        </div>

        <div>
          {isEnrolled ? (
            <Link
              to={certificationPaths.overview(
                certificationRouteKey(certification),
              )}
              className="certification-hero-cta flex-inline items-center body-s-medium"
            >
              {t("certification.details.continue")}
            </Link>
          ) : (
            <a
              href={`#${PATH_DECISION_ANCHOR_ID}`}
              className="certification-hero-cta flex-inline items-center body-s-medium"
            >
              {t("certification.details.choosePath")}
            </a>
          )}
        </div>
      </div>
    </section>
  );
};

export default Hero;
